import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isModalAddTransactionOpen: false,
  isModalSelectorOpen: false,
  isCurrencyView: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleModalAddTransaction: state => {
      state.isModalAddTransactionOpen = !state.isModalAddTransactionOpen;
    },
    toggleModalSelector: state => {
      state.isModalSelectorOpen = !state.isModalSelectorOpen;
    },
  },
  extraReducers: {},
});

export const { toggleModalAddTransaction, toggleModalSelector } =
  globalSlice.actions;
export default globalSlice.reducer;
